import {computed, Injectable, Signal} from '@angular/core';
import {ProjectRoleType, ProjectUserDetailResponse} from '@frontend/shared-api';
import {ProjectRoleConfig} from '../directives/project-role-access.directive';

@Injectable({
  providedIn: 'root',
})
export class ProjectRoleConfigService {
  createProjectManagerOnlyConfig(projectId: number): ProjectRoleConfig {
    return {
      projectId,
      roles: [ProjectRoleType.PROJECT_MANAGER],
      allowTenantAdmin: false,
    };
  }

  createProjectManagerWithTenantAdminConfig(
    projectId: number,
    userDetail?: ProjectUserDetailResponse,
  ): ProjectRoleConfig {
    return {
      projectId,
      roles: [ProjectRoleType.PROJECT_MANAGER],
      allowTenantAdmin: true,
      userDetail,
    };
  }

  createProjectManagerWithTenantAdminConfigOrNull(
    projectId: number | undefined,
  ): ProjectRoleConfig | null {
    return projectId ? this.createProjectManagerWithTenantAdminConfig(projectId) : null;
  }

  createProjectManagerOnlyConfigSignal(projectIdSignal: Signal<number>): Signal<ProjectRoleConfig> {
    return computed(() => this.createProjectManagerOnlyConfig(projectIdSignal()));
  }
}
